import {
    GetAccidentTimeline,
    SetAllRead
} from '../../api/accident';
import {
    arrayUnique
} from '../../util/Utils';

const state = {
    data: [],
    currentPage: 1,
    loadMoreStatus: 'loaded',
    eBoxInfo: [],
    total: 0,
    latest: {}, //获取最新的数据
}

const getters = {
    latest: (state) => {
        // console.log(state)
        if (state.length == 0) {

            return null
        }
        return {
            name: state.latest.loop_name,
            deviceName: state.latest.device_name,
            eventName: state.latest.event_name || '未知',
            code: state.latest.id,
            classify: state.latest.alarm_event_type,
            type: state.latest.alarm_type_desc,
            start: state.latest.start_time,
            isRead: state.latest.read_check,
        }
    },
    notifycation: (state) => {
        // console.log(state.data)
        return state.data.map(item => {
            return {
                name: item.loop_name || item.device_name,
                deviceName: item.device_name,
                eventName: item.event_name || '未知',
                code: item.id,
                classify: item.alarm_event_type,
                type: item.alarm_type_desc,
                start: item.start_time,
                isRead: item.read_check,
                device:item.device_details,
                incident_classification:item.incident_classification,
                alarm_event_type:item.alarm_event_type
            }
        })
    },
    status: (state) => {
        return state.loadMoreStatus;
    },
    total: (state) => {
        return state.total;
    },
    eBoxInfo: (state) => () => state.eBoxInfo

}

const mutations = {
    setlatest(state, payload) {
        if (payload.data.details.records.length == 0) {
            state.latest == null
        } else {
            state.latest = payload.data.details.records[0]
        }
    },
    addPage(state) {
        state.currentPage++;
    },
    resetPage(state) {
        state.currentPage = 1;
    },
    resetloadMoreStatus(state) {
        state.loadMoreStatus = 'loaded';
    },
    setloadMoreStatus(state, payload) {
        state.loadMoreStatus = payload;
    },
    setNotifycationData(state, payload) {
        if (payload.data.details.records.length > 0 && payload.data.details.total <= 20) {
            state.loadMoreStatus = 'noMore'
        }

        state.data = payload.data.details.records;
        state.total = payload.data.details.total;
    },
    appendData(state, payload) {
        state.data = [payload, ...state.data];
        state.total++;
        state.latest = payload
    },
    loadMoreData(state, payload) {
        state.data = arrayUnique([...state.data, ...payload.data.details.records], 'id')
        state.total = payload.data.details.total;
    },
    removeData(state, payload) {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id === payload) {
                state.data.splice(i, 1);
            }
        }
    },
    removeAll(state, payload) {
        state.data = [];
        state.total = 0;
        state.loadMoreStatus = 'loaded';
        state.currentPage = 1;
    },
    setEBoxInfo(state, payload) {
        // console.log('设置Ebox状态', payload)
        state.eBoxInfo = payload;
    },
    setNotifycationIsRead(state, payload) {
        // state.data = state.data.filter(item => item.id !== payload);
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id === payload) {
                state.data.splice(i, 1, {
                    ...state.data[i],
                    read_check: true
                });
            }
        }
    },
    totalSub(state) {
        if (state.total > 0) {
            state.total--;
        }
    },
    totalAdd(state) {
        state.total++;
    }
}

const actions = {
    setlatest(context) {
        GetAccidentTimeline({
            page: 1,
            size: 1,
            projectId: context.rootGetters.projectId
        }).then(response => {
            // console.log(response.data)
            context.commit('setlatest', response.data);
        }).catch(error => {
            console.error(error);
        })
    },

    setNotifycationData(context) {
        // console.log(context.rootGetters.projectId);
        context.commit('resetloadMoreStatus');
        GetAccidentTimeline({
            page: 1,
            size: 20,
            readType: 'UNREAD',
            projectId: context.rootGetters.projectId
        }).then(response => {
            console.log(response)
            context.commit('setNotifycationData', response.data);
        }).catch(error => {
            console.error(error);
        })
    },
    loadMoreData(context) {
        context.commit('setloadMoreStatus', 'loading');
        GetAccidentTimeline({
            page: context.state.currentPage,
            size: 20,
            readType: 'UNREAD',
            projectId: context.rootGetters.projectId
        }).then(response => {
            context.commit('loadMoreData', response.data);
            if (context.state.currentPage >= response.data.data.details.pages) {
                context.commit('setloadMoreStatus', 'noMore')
            } else {
                context.commit('setloadMoreStatus', 'loaded')
            }
        }).catch(error => {
            console.error(error);
        })
    },
    clearAllNotifycation(context) {
        SetAllRead(context.rootGetters.projectId)
            .then(response => {
                if (response.data.status) {
                    context.commit('removeAll');
                }
            })
            .catch(error => {
                console.error(error);
            })
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}